import React from "react";
import RegrasDoItem from "./RegrasDoItem";
import { InterviewCamera2Detection, InterviewItem, InterviewStep } from "../../types/Interview";

interface Props {
  item: InterviewItem;
  numero?: number;
  busy: boolean;
  versaoCampos: number;
  onEditar: (item: InterviewItem, campo: keyof InterviewCamera2Detection, texto: string) => void;
  onEditarPassos?: (item: InterviewItem, passos: InterviewStep[]) => void;
  onEditarItem?: (item: InterviewItem, campo: "question" | "value", texto: string) => void;
  onAlternarCritico?: (item: InterviewItem) => void;
  onRemover?: (item: InterviewItem) => void;
  onPedirRegras?: (item: InterviewItem) => void;
  sugestaoStatus?: "carregando" | "pronta" | null;
}

/** As duas abas usam o mesmo cartão; os campos de detecção da C2 têm destino próprio. */
export default function RegrasCamera2DoItem({
  item, numero, busy, versaoCampos, onEditar, onEditarPassos, onEditarItem,
  onAlternarCritico, onRemover, onPedirRegras, sugestaoStatus,
}: Props) {
  const visual: InterviewItem = { ...item, detection: item.detection.camera2 ?? {} };
  return (
    <RegrasDoItem
      key={versaoCampos}
      camera2
      item={visual}
      numero={numero}
      busy={busy}
      sugestaoStatus={sugestaoStatus}
      onEditarItem={(_, campo, texto) => onEditarItem?.(item, campo, texto)}
      onAlternarCritico={() => onAlternarCritico?.(item)}
      onRemover={() => onRemover?.(item)}
      onEditarFaceta={(_, campo, texto) => {
        if (campo !== "speech") onEditar(item, campo, texto);
      }}
      onEditarPassos={(_, passos) => onEditarPassos?.(item, passos)}
      onPedirAoAssistente={() => onPedirRegras?.(item)}
    />
  );
}
